// extracted by mini-css-extract-plugin
export default {"content":"HygienePages_content__MVjqF","search-area":"HygienePages_search-area__k4TFB","searchbox-container":"HygienePages_searchbox-container__NEkpP"};